import { Auth } from '../../ng2/shared/auth/auth.service';
angular.module('nv-data-tools-portal').config(configBlock);

// Documentation can be found here: https://github.com/auth0/angular-jwt#jwtinterceptor
// Additional options include:
// -not sending the JWT for specific requests
// -not sending the JWT for template requests
// -sending different tokens based on URLs
function configBlock($httpProvider, jwtOptionsProvider, PublicConfig) {
  jwtOptionsProvider.config({
    tokenGetter: [
      'Auth',
      function(auth: Auth) {
        return auth.getIdToken();
      },
    ],
    whiteListedDomains: [PublicConfig.NV_API_DOMAIN],
  });

  $httpProvider.interceptors.push('jwtInterceptor');
}
